import { render } from "./InfoComponent.vue?vue&type=template&id=4e49b9e9&scoped=true"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"

import "./InfoComponent.vue?vue&type=style&index=0&id=4e49b9e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e49b9e9"]])

export default __exports__